import {mapActions} from "vuex";

export default {
  methods: {
    ...mapActions({
      generateCodigo: "producto/generarCodigo"
    }),
    setInicio(parte, value) {
      this.generateCodigo({parte, dato: value})
    },
    isWeb() {
      const permisos = JSON.parse(window.localStorage.permissions)
      return permisos.some(p => p.value === "WEB" || p.value === "ADMIN")
    }
  }
}
